export class MediaTypeFileTypeModel {
    public mediaTypeFileTypeId: string;
    public mediaTypeCode: string;
    public fileTypeCode: string;
}